



import ProjectPage from '../projectManagement/project.vue'
export default {
  name: 'projectOEM',
  components: { ProjectPage },
}
